<mat-form-field class="full-width">
    <mat-select [(value)]="workstationSelected" placeholder="Puesto">
        <mat-option *ngFor="let workstation of workstations" [value]="workstation">
            {{ workstation }}
        </mat-option>
    </mat-select>
</mat-form-field>

<h1 *ngIf="lastCall" mat-dialog-title>
    Último llamado en esta terminal</h1>
<mat-divider *ngIf="lastCall"></mat-divider>
<table *ngIf="lastCall" class="table-content">
    <tr>
        <th class="cell-date">Fecha</th>
        <th class="cell-date">Llamador</th>
        <th class="cell-patient">Paciente</th>
        <th class="cell-date">Acción</th>
        <th class="cell-date"></th>
        <th class="cell-date"></th>
    </tr>

    <tr>
        <td class="cell-date">{{ lastCall.Date | date : 'dd/MM/yyyy HH:mm' }}</td>
        <td class="cell-date">{{ lastCall.CallerNumber }}</td>
        <td class="cell-patient">{{ lastCall.PatientFullName }}</td>
        <td class="cell-date">{{ lastCall.ActionName }}</td>
        <td class="cell-date"><mat-icon *ngIf="lastCall.IsDiscapacitado">accessible</mat-icon></td>
        <td class="cell-date">
            <mat-icon *ngIf="!lastCall.LoadingAction" (click)="callPatient(lastCall)"> add_alert </mat-icon>
            <mat-spinner *ngIf="lastCall.LoadingAction" [diameter]="15"></mat-spinner>
        </td>
    </tr>
</table>

<div class="card-inline">
    <h1 class="card-inline" mat-dialog-title>Pacientes en espera</h1>
    <button class="card-inline" matTooltip="Actualizar" (click)="loadOrientationPatientSearchItems()" mat-mini-fab>
        <mat-icon>refresh</mat-icon>
    </button>
</div>
<mat-divider></mat-divider>
<div class="table-scroll">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <table *ngIf="!loading" class="table-content">
        <tr>
            <th class="cell-date">Fecha</th>
            <th class="cell-date">Llamador</th>
            <th class="cell-patient">Paciente</th>
            <th class="cell-date">Acción</th>
            <th class="cell-date"></th>
            <th class="cell-date"></th>
        </tr>

        <tr *ngFor="let orientationPatientSearchItem of orientationPatientSearchItems">
            <td class="cell-date">{{ orientationPatientSearchItem.Date | date : 'dd/MM/yyyy HH:mm' }}</td>
            <td class="cell-date">{{ orientationPatientSearchItem.CallerNumber }}</td>
            <td class="cell-patient">{{ orientationPatientSearchItem.PatientFullName }}</td>
            <td class="cell-date">{{ orientationPatientSearchItem.ActionName }}</td>
            <td class="cell-date"><mat-icon *ngIf="orientationPatientSearchItem.IsDiscapacitado">accessible</mat-icon></td>
            <td class="cell-date">
                <mat-icon *ngIf="!orientationPatientSearchItem.LoadingAction" (click)="callPatient(orientationPatientSearchItem)"> add_alert </mat-icon>
                <mat-spinner *ngIf="orientationPatientSearchItem.LoadingAction" [diameter]="15"></mat-spinner>
            </td>
        </tr>
    </table>
</div>
